import React, { useEffect } from 'react';

const loadingContainerStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  marginBottom: '1rem',
  paddingLeft: '1rem'
};

const loadingBubbleStyle = {
  backgroundColor: '#FFFFFF',
  borderRadius: '18px 18px 18px 4px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  padding: '12px 16px',
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  maxWidth: '80px',
  minHeight: '44px'
};

const typingDotStyle = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: '#A1B7A5',
  opacity: 0.3
};

const animationCSS = `
@keyframes typingAnimation {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1.2);
  }
}

.typing-dot {
  animation: typingAnimation 1.8s ease-in-out infinite;
}

.typing-dot-1 { animation-delay: 0s; }
.typing-dot-2 { animation-delay: 0.3s; }
.typing-dot-3 { animation-delay: 0.6s; }
`;

const MobileChatLoader: React.FC = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = animationCSS;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div style={loadingContainerStyle}>
      <div style={loadingBubbleStyle}>
        <div 
          style={{...typingDotStyle}} 
          className="typing-dot typing-dot-1"
        />
        <div 
          style={{...typingDotStyle}} 
          className="typing-dot typing-dot-2"
        />
        <div 
          style={{...typingDotStyle}} 
          className="typing-dot typing-dot-3"
        />
      </div>
    </div>
  );
};

export default MobileChatLoader;